export default "__VITE_ASSET__B83pYrJ1__"